function RiskAllele() {
  return (
    <div>
      <li className="bullet-item">
        The risk allele is the allele associated with the phenotype as provided by the GWAS catalogue or
        ClinVar.
      </li>
    </div>
  );
}

export default RiskAllele;
